import { Component, EventEmitter, forwardRef, Inject, Input, Output } from '@angular/core';

import { CompanyService } from '../companies/company.service';
import { SessionService } from '../sessions/session.service';

@Component({
  selector   : 'wor-vehicle-form-music',
  template: require('./vehicle.form-music.component.html')
})
export class VehicleFormMusicComponent {
  @Input() vehicle: any;
  @Input() company: any;
  @Input() customer: any;
  @Input() body_types_limited: any[];
  @Input() plateDuplicate: boolean;

  @Output() onCheckPlate = new EventEmitter<void>();
  @Output() onDelete     = new EventEmitter<void>();
  @Output() onArchive    = new EventEmitter<void>();

  constructor(
    @Inject(forwardRef(() => CompanyService)) public companyService: CompanyService,
    @Inject(forwardRef(() => SessionService)) public sessionService: SessionService
  ) {}

  canUnarchiveVehicle(): boolean {
    return this.vehicle.id
      && this.vehicle.archived
      && !this.customer.archived;
  }
}
